import axiosInstance from '@/axiosInstance'

const state = () => ({
  modules: [],
  loading: false,
  currentModuleId: null,
})

const mutations = {
  setModules(state, modules) {
    state.modules = modules
  },
  setLoading(state, status) {
    state.loading = status
  },
  setCurrentModuleId(state, id) {
    state.currentModuleId = id
  },
}

const actions = {
  async fetchModules({ state, commit }) {
    if (state.modules.length > 0) return

    commit('setLoading', true)
    try {
      const response = await axiosInstance.get('modules/')
      commit('setModules', response.data || [])
    } catch (error) {
      console.error('Error fetching modules:', error?.response?.data || error.message)
    } finally {
      commit('setLoading', false)
    }
  },

  // Fetch and store module ID by its name
  async fetchModuleIdByName({ dispatch, getters, commit }, moduleName) {
    await dispatch('fetchModules')

    const id = getters.getModuleIdByName(moduleName)
    if (id) {
      commit('setCurrentModuleId', id)
    } else {
      console.warn(`Module "${moduleName}" not found.`)
    }
    return id
  },
}

const getters = {
  getModules: (state) => state.modules,

  getModuleByName: (state) => (name) =>
    state.modules.find((mod) => mod.module_name?.toLowerCase() === name.toLowerCase()) || null,

  getModuleIdByName: (state, getters) => (name) => {
    const mod = getters.getModuleByName(name)
    return mod?.id || null
  },

  currentModuleId: (state) => state.currentModuleId,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}